<div class="forgot-page" role="main" aria-label="Forgot password page">
    <div class="forgotWrapper">
        <div class="forgot-card">
            <div class="login-wrap">
                <h3 [appTranslate]="'FORGOT_PASSWORD'"></h3>
                <div class="form-group">
                    <label for="forgot-email" [appTranslate]="'EMAIL'"></label>
                    <input id="forgot-email" type="email" class="form-control" name="email"
                        [(ngModel)]="forgotPassModel.Email" aria-describedby="forgot-email-errors">
                    <div id="forgot-email-errors" class="errors">
                        <app-error [errors]="errors" [ErrorKey]="'Email'" class="error-feedback"></app-error>
                        <app-error [errors]="errors" [ErrorKey]="'USER_NOT_EXISTS'" class="error-feedback"></app-error>
                    </div>
                </div>

                <div class="loginBtn">
                    <button type="button" class="btn-primary" (click)="forgotPassword()"><span
                            [appTranslate]="'CONFIRM'"></span> </button>
                </div>
                <!-- <div class="errors">
                        <app-error [errors]="errors" [ErrorKey]="''" class="error-feedback"></app-error>
                    </div> -->

                <div *ngIf="successfulReg" >
                    <div class="profile-success-banner">
                        <div class="success-banner-icon">
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <circle cx="11" cy="11" r="11" fill="rgba(119, 193, 30, 1)" />
                                <path d="M6 11.5L9.2 14.5L16 8" stroke="white" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" />
                            </svg>
                        </div>
                        <span class="success-banner-text" [appTranslate]="'MAIL_SENT'"></span>
                    </div>
                </div>
                 <button type="button" class="btn-link" (click)="redirect()" [appTranslate]="'TO_LOGIN'"
                        aria-label="Go to login"></button>

            </div>
        </div>
    </div>
</div>